import { render, staticRenderFns } from "./BookHeader.vue?vue&type=template&id=9d7b167e&scoped=true"
import script from "./BookHeader.vue?vue&type=script&lang=js"
export * from "./BookHeader.vue?vue&type=script&lang=js"
import style0 from "./BookHeader.vue?vue&type=style&index=0&id=9d7b167e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7b167e",
  null
  
)

export default component.exports